<template>
    <span>
        <abbr :title="abbrTitle" ref="abbr"><slot /></abbr><!--
     --><b-popover
            custom-class="lexicon-definition__popover"
            :show="popoverVisible"
            :disabled="error"
            :target="() => $refs.abbr"
            :boundary-padding="20"
            triggers="hover"
            placement="top"
            @show="handleShow"
            @hide="handleHide"
        >
            <template v-slot:title>
                <span class="row">
                    <span class="col">
                        {{ word && word.label }}
                    </span>
                    <span class="col-auto">
                        <button class="close" aria-label="Fermer la définition" @click="close">&times;</button>
                    </span>
                </span>
            </template>

            <template v-if="loading">
                <div class="d-flex align-items-center justify-content-center mw-100" style="width: 500px; height: 150px">
                    <span class="spinner-grow spinner-grow-sm text-primary"></span>
                </div>
            </template>
            <template v-else-if="word">
                <div class="lexicon-definition__definition" v-html="word.definition"></div>
            </template>
        </b-popover><!--
 --></span>
</template>

<script>
    import { getLexiconWord } from "../api";
    import { BPopover } from 'bootstrap-vue';
    import { stripTags } from "../util";

    export default {
        components: {
            BPopover,
        },
        props: {
            wordId: String,
        },
        data() {
            return {
                word: null,
                loading: true,
                popoverVisible: false,
                error: false,
            }
        },
        computed: {
            abbrTitle() {
                if(this.error) {
                    return null;
                }
                return this.word
                    ? stripTags(this.word.definition).trim()
                    : '';
            },
        },
        methods: {
            async handleShow() {
                this.popoverVisible = true;
                if(!this.word) {
                    this.loading = true;
                    this.word = await getLexiconWord(this.wordId)
                        .catch(() => {
                            this.error = true;
                            this.close();
                        });
                    this.loading = false;
                }
            },
            handleHide() {
                this.popoverVisible = false;
            },
            close() {
                this.popoverVisible = false;
            },
        },
    }
</script>
